/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


  jQuery( function($) 
{
  setTimeout(function(){
      //begin updates to alternate text, title, and aria-label if needed only
	var imgCnt = 1;
	var proImg = 1;
	jQuery('img').each(function () {
		var curAlt = jQuery(this).attr('alt');
		var curTitle = jQuery(this).attr('title');
		var curAriaLbl = jQuery(this).attr('aria-label');
		//no alt text or empty alt text or undefined
		if (!curAlt || curAlt === '' || curAlt === 'undefined') {
			jQuery(this).attr('alt', ''); //decorative	
			if (jQuery(this).parent().hasClass('zoomImg')) {
				jQuery(this).attr('alt', 'Current Product Image #' + proImg);
				proImg++;
			} else if (jQuery(this).parent('a')) {
				if (jQuery(this).hasClass('product-single__thumbnail')) {
					jQuery(this).attr('alt', 'product Image #' + proCnt);
					proImg++;
				} else {
					jQuery(this).attr('alt', 'decorative Image #' + imgCnt);
					imgCnt++;
                }
			} else {
				//if empty then should not contain title or aria-label
				jQuery(this).removeAttr('aria-label');
				jQuery(this).removeAttr('title');
			}

		} else {
			
			if (jQuery(this).parent().hasClass('zoomImg')) {
				jQuery(this).attr('alt', curAlt + ' Enlarged Product Image #' + proImg);
				proImg++;
			} else if (jQuery(this).parent('a')) {
				if (jQuery(this).hasClass('product-single__thumbnail')) {
					jQuery(this).attr('alt', curAlt + ' Thumbnail Product Image #' + proCnt);
					proImg++;
				} else {
					jQuery(this).attr('alt', curAlt);
				}
			} else {
				//alt present so we should leave alt alone
				jQuery(this).attr('alt', curAlt);
				//if title present add an aria-label as well
				if (!curTitle || curTitle === '' || curTitle === 'undefined') { }
				else {
					//first check to make sure it doesn't already have aria-label
					if (!curAriaLbl || curAriaLbl === '' || curAriaLbl === 'undefined') {
						jQuery(this).attr('aria-label', curTitle);
					}
				}
			}
		}
		imgCnt++;
	});
	//end updates to alternate text, title, and aria-label if needed only
    //fix weird shopfiy link
    jQuery('.hidden-pocket').find('[aria-describedby="a11y-new-window-message"]').append('<span class="sr-only">Hidden shopify message</span>');
},1200);
      //fix landmarks
      var navCnt = 1;
		jQuery("nav").each( function(){
			jQuery(this).attr("aria-label","Navigation Menu #"+navCnt);
			navCnt++;
		});
        jQuery('[data-section-type="announcement-bar"]').attr('role','region').attr('aria-label','Announcement Bar');
        var footcnt = 0;
        jQuery('.shopify-section-group-footer-group').each(function(){
          if(footcnt < 1){
            jQuery(this).attr('role','region').attr('aria-label','Upper footer section');
            footcnt++;
          }
        });

      //fix any missing h1s
		var h1Cnt = 0;
		jQuery("h1").each(function () {			
			h1Cnt++;
		});
		if(h1Cnt == 0){
			jQuery("#main").prepend('<div role="region" aria-label="Main Heading"><h1 class="sr-only">' + jQuery("title").html() + '</h1></div>');			
		}
  

     setTimeout(function(){
      //fix cart aria - as this does not open a popup cart there is no need for incorrectly formatted aria-expanded attribute within link
      jQuery('.header__cart-toggle').find('.header__cart-icon').removeAttr('aria-expanded');
      //description popups - aira wrong place
       jQuery('.expandable-content--expandable').each(function(){
         //jQuery(this).removeAttr('aria-expanded');
       });
     }, 1800);
    //fix aside inside another landmark
    jQuery('aside').each(function(){
		var el = jQuery(this),
    		html = el.html(),
			attrs = {
					"id": el.attr('id'),
					"class": el.attr('class'),
					"style": el.attr('style')
				};			
          el.replaceWith(jQuery('<div></div>').html(html).attr(attrs));
		});
      jQuery('.admin-bar').attr('role','region').attr('aria-label','admin bar');

      jQuery('.header__logo-image').attr('alt','Supplement First Logo');
  jQuery('#order-note').removeAttr('aria-hidden');
  jQuery('#order-note').prepend('<label class="sr-only" for="i_note">Instructions</label>').find('textarea').attr('id','i_note');

  /*/Adjust recharge widget layout
  setTimeout(function(){
  jQuery('.rc-template__button-group').each(function(){
    jQuery(this).find('.onetime-radio').each(function(){
      jQuery(this).find('div.price-label').remove();
    });
    jQuery(this).find('.subscription-radio').each(function(){
      jQuery(this).find('div.price-label').remove();
    });
  });
  },500);*/
    });     
